module.exports = __webpack_public_path__ + "assets/img/29.c541b07e.jpg";